/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedNotificationTradeRequestAppointmentTooltipConfigQueryVariables = {
    userId?: string | null;
};
export type pdpSharedNotificationTradeRequestAppointmentTooltipConfigQueryResponse = {
    readonly viewer: {
        readonly disableRequestAppointment: boolean | null;
        readonly anchorLists: ReadonlyArray<{
            readonly members: ReadonlyArray<{
                readonly anchor: {
                    readonly sourceId: string | null;
                } | null;
            } | null> | null;
        } | null> | null;
        readonly user: {
            readonly tradeFirm: {
                readonly serviceId: string | null;
            } | null;
        } | null;
    } | null;
};
export type pdpSharedNotificationTradeRequestAppointmentTooltipConfigQuery = {
    readonly response: pdpSharedNotificationTradeRequestAppointmentTooltipConfigQueryResponse;
    readonly variables: pdpSharedNotificationTradeRequestAppointmentTooltipConfigQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "disableRequestAppointment",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disablePdpRequestAppointment"
    }
  ],
  "storageKey": "isEnabled(key:\"disablePdpRequestAppointment\")"
},
v2 = [
  {
    "kind": "Literal",
    "name": "listNames",
    "value": [
      "REQUEST_APPOINTMENT_MVP"
    ]
  }
],
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "members",
  "storageKey": null,
  "args": null,
  "concreteType": "AnchorListMember",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "anchor",
      "storageKey": null,
      "args": null,
      "concreteType": "Anchor",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sourceId",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v4 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationTradeRequestAppointmentTooltipConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "anchorLists",
            "storageKey": "anchorLists(listNames:[\"REQUEST_APPOINTMENT_MVP\"])",
            "args": (v2/*: any*/),
            "concreteType": "AnchorList",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v4/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeFirm",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationTradeRequestAppointmentTooltipConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "anchorLists",
            "storageKey": "anchorLists(listNames:[\"REQUEST_APPOINTMENT_MVP\"])",
            "args": (v2/*: any*/),
            "concreteType": "AnchorList",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v4/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeFirm",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationTradeRequestAppointmentTooltipConfigQuery",
    "id": "app-buyer-finding/246.0.0-2020-01-09T09:52:44.262Z/pdpSharedNotificationTradeRequestAppointmentTooltipConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '8f72b07e3fb9c7a0df2a06dd866c0849';
export default node;
